module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "基础信息",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动封面"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）")]), _vm._v(" "), _c('div', [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.wximageurl + _vm.form.ad_pic,
      "inline": ""
    },
    on: {
      "click": _vm.handleImgChange
    }
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "activity_name",
      "rules": {
        required: true,
        message: '活动名称必填',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "活动名称"
    },
    model: {
      value: (_vm.form.activity_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_name", $$v)
      },
      expression: "form.activity_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预告时间",
      "prop": "activity_release_time"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form.activity_release_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_release_time", $$v)
      },
      expression: "form.activity_release_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动描述"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否返佣"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "false"
    },
    model: {
      value: (_vm.form.is_activity_rebate),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_activity_rebate", $$v)
      },
      expression: "form.is_activity_rebate"
    }
  }, [_vm._v("不返佣")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否包邮"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    },
    model: {
      value: (_vm.form.is_free_shipping),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_free_shipping", $$v)
      },
      expression: "form.is_free_shipping"
    }
  }, [_vm._v("包邮")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    },
    model: {
      value: (_vm.form.is_free_shipping),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_free_shipping", $$v)
      },
      expression: "form.is_free_shipping"
    }
  }, [_vm._v("商品自身运费模板")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单取消",
      "prop": "validity_period"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("客户下单")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "15",
      "width": "10"
    },
    model: {
      value: (_vm.form.validity_period),
      callback: function($$v) {
        _vm.$set(_vm.form, "validity_period", $$v)
      },
      expression: "form.validity_period"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("分钟后未支付的订单，将自动取消")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动商品类型"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal"
    },
    model: {
      value: (_vm.form.item_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_type", $$v)
      },
      expression: "form.item_type"
    }
  }, [_vm._v("实体类商品")])], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "绑定商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "设置商品",
      "shadow": "naver"
    }
  }, [(_vm.form.items.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.form.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货号",
      "prop": "item_bn",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "special_type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.special_type == 'drug') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("处方药")]) : _c('span', {
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v("非处方药")])]
      }
    }], null, false, 2651025645)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动价",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "min": "0.01",
            "size": "mini"
          },
          model: {
            value: (scope.row.activity_price),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_price", $$v)
            },
            expression: "scope.row.activity_price"
          }
        })]
      }
    }], null, false, 1023215225)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "width": "90",
            "size": "mini"
          },
          model: {
            value: (scope.row.activity_store),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_store", $$v)
            },
            expression: "scope.row.activity_store"
          }
        })]
      }
    }], null, false, 3447741873)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "每人限购",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.limit_num),
            callback: function($$v) {
              _vm.$set(scope.row, "limit_num", $$v)
            },
            expression: "scope.row.limit_num"
          }
        })]
      }
    }], null, false, 3741221881)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.sort),
            callback: function($$v) {
              _vm.$set(scope.row, "sort", $$v)
            },
            expression: "scope.row.sort"
          }
        })]
      }
    }], null, false, 243219967)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteItemRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 1914607797)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "店铺",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用店铺"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.shopTypeChange
    },
    model: {
      value: (_vm.form.use_all_shops),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_all_shops", $$v)
      },
      expression: "form.use_all_shops"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全部适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("指定店铺适用")])], 1)], 1), _vm._v(" "), (!_vm.zdShopHidden) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDistributorAction
    }
  }, [_vm._v("选择店铺")]), _vm._v(" "), (_vm.distributor_info.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.distributor_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteDistritutorRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 3521329561)
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (this.copy_flag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v(" 复制活动 ")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v(" 保存 ")])], 1)], 1), _vm._v(" "), _c('StoreSelect', {
    attrs: {
      "store-visible": _vm.storeVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relShopIds,
      "get-status": _vm.setStatus
    },
    on: {
      "chooseStore": _vm.chooseStoreAction,
      "closeStoreDialog": _vm.closeStoreDialogAction
    }
  }), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.distributorVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relDistributorIds,
      "get-status": _vm.setDistributorStatus
    },
    on: {
      "chooseStore": _vm.chooseDistributorAction,
      "closeStoreDialog": _vm.closeDistributorDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19c67758", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c67758"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/seckill/add.vue
// module id = 2507
// module chunks = 0